<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Edit Teacher" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-text-field
              outlined
              :hide-details="nameErrors.length === 0"
              dense
              :error-messages="nameErrors"
              v-model="Teacher.name"
              label="Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              outlined
              dense
              hide-details
              v-model="Teacher.phoneNumber"
              label="Phone Number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              outlined
              dense
              hide-details
              v-model="Teacher.email"
              label="Email Address"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12">
            <v-text-field
              outlined
              hide-details
              dense
              v-model="Teacher.address"
              label="Address"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-text-field
              outlined
              hide-details
              dense
              v-model="Teacher.city"
              label="City"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              outlined
              dense
              hide-details
              v-model="Teacher.state"
              label="State"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              outlined
              dense
              hide-details
              v-model="Teacher.zip"
              label="Zip Code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-textarea
              outlined
              dense
              hide-details
              auto-grow
              v-model="Teacher.description"
              :label="$t('labels.description')"
            ></v-textarea>
          </v-col>
					<!-- portal access work start -->
          <v-col cols="12" sm="12" md="4">
            <v-switch
							class="ma-0"
							v-model="Teacher.portalAccess"
							@change="portalAccessChanged"
							outlined
              dense
              autofocus
              label="Portal Access"
            ></v-switch>
          </v-col>
					<v-col cols="12" sm="12" md="4" v-if="Teacher.portalAccess">
						<v-text-field
							outlined
							@input="portalAccessChanged"
							dense
							hide-details
							v-model="Teacher.userData.loginEmail"
							label="Login Email"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="4" v-if="Teacher.portalAccess">
						<v-text-field
							outlined
							dense
							type="password"
							@input="portalAccessChanged"
							hide-details
							v-model="Teacher.userData.loginPassword"
							label="Login Password"
						></v-text-field>
					</v-col>
					<!-- portal access work ends -->
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import teacherService from "../service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false,
    },
    editTeacher: {
      type: Object,
    },
  },
  name: "update-Teacher",
  data() {
    return {
      loading: false,
      dialog: false,
      Teacher: {
				portalAccess: false,
				portalStatusUpdated: false,
				userData: {
					loginEmail: null,
					loginPassword: null
				},
        name: null,
        email: null,
        phoneNumber: null,
        contactName: null,
        address: null,
        city: null,
        state: null,
				LoginUserId: null,
        zip: null,
        note: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    Teacher: {
      name: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Teacher.name.$dirty) return errors;
      if (!this.$v.Teacher.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    editDialog(val) {
      
      if (this.editTeacher && this.editTeacher.LoginUser) {
				this.Teacher.userData = {
					loginEmail: this.editTeacher.LoginUser.email,
					loginPassword: this.editTeacher.LoginUser.password
				}
			}
			this.Teacher = {
				...this.editTeacher,
				userData: this.Teacher.userData
			}
			this.Teacher.portalStatusUpdated = false
      console.log('open this.Teacher ', this.Teacher)

      this.dialog = val;
    },
  },
  methods: {
		portalAccessChanged() {
			this.Teacher.portalStatusUpdated = true
		},
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Teacher = {
				userData: {
					loginEmail: null,
					loginPassword: null
				},
				LoginUserId: null,
				portalAccess: false,
				portalStatusUpdated: false,
        name: null,
        email: null,
        phoneNumber: null,
        contactName: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        note: null,
      };
      this.$v.$reset();
    },
    submit() {
      console.log('this.Teacher', this.Teacher)
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return teacherService
          .update(this.Teacher.id, this.Teacher)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Teacher is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
